import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "transactions",
  "use": "transactions-usage",
  "viewBox": "0 0 16.84 13.44",
  "content": "<symbol viewBox=\"0 0 16.84 13.44\" id=\"transactions\"><title>transactionsAsset 1</title>\r\n<polygon points=\"13.37 7.07 12.66 6.38 14.94 4.03 0.7 4.03 0.7 3.03 14.92 3.03 12.59 0.71 13.3 0 16.84 3.53 13.37 7.07\" />\r\n<polygon points=\"3.53 13.44 0 9.9 3.46 6.37 4.17 7.06 1.89 9.39 16.13 9.39 16.13 10.39 1.91 10.39 4.24 12.73 3.53 13.44\" />\r\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol